import { segment, track } from '@mc/track-event'

export const trackHubFooterTrailerClick = (videoId: string) => {
  track(segment.EventTypes.EXPLAINER_PAGE_CLICK, {
    category: 'video-player',
    location: 'video-player',
    action: 'Watch Trailer',
    page_type: 'explainer-page',
    class_type: 'camp',
    content_type: 'Camp Marketing',
    content_id: videoId,
  })
}

export const hubFooterVideoEventAttributes = {
  category: 'footer-cta',
  location: 'footer-cta',
  page_type: 'explainer-page',
  class_type: 'camp',
  content_type: 'Camp Marketing',
}

export const trackCampHubTrailerClick = (videoId: string | number) => {
  track(segment.EventTypes.EXPLAINER_PAGE_CLICK, {
    category: 'video-player',
    location: 'video-player',
    action: 'Watch Trailer',
    page_type: 'explainer-page',
    class_type: 'camp',
    content_type: 'Camp Marketing',
    content_id: videoId,
  })
}

export const campHubTrailerVideoEventAttributes = {
  category: 'video-player',
  location: 'video-player',
  page_type: 'explainer-page',
  class_type: 'camp',
  content_type: 'Camp Marketing',
}

type TrailerEventProps = {
  slug: string
  isLive: boolean
  contentId: string
}

export const trackCampClassTrailerClick = ({
  slug,
  isLive,
  contentId,
}: TrailerEventProps) => {
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'video-player',
    location: 'video-player',
    action: 'Watch Trailer',
    page_type: 'class-page',
    class_type: 'camp',
    content_type: 'Camp Trailer',
    content_id: contentId,
    class: slug,
    instructor_coming_soon: !isLive,
  })
}

export const getCampClassTrailerVideoEventAttributes = ({
  slug,
  isLive,
  contentId,
}: TrailerEventProps) => ({
  category: 'video-player',
  location: 'video-player',
  page_type: 'class-page',
  class_type: 'camp',
  content_type: 'Camp Trailer',
  content_id: contentId,
  class: slug,
  instructor_coming_soon: !isLive,
})
